import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubHeader from '../SubHeader/SubHeader';
import Footer from '../Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../../styles/QRResult.css';

function QRResult() {
  const navigate = useNavigate();
  const [qrResult, setQrResult] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const result = localStorage.getItem('qrResult');
    if (!result) {
      navigate('/dashboard');
    } else {
      setQrResult(result);
    }
  }, [navigate]);

  const handleBack = () => {
    localStorage.removeItem('qrResult');
    navigate('/dashboard');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(qrResult);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="page-container">
      <SubHeader title="Kết quả quét QR" />

      <main className="qr-result-main">
        <div className="qr-result-wrapper">
          <div className="qr-result-box">
            <div className="qr-result-header">
              <h3>Nội dung mã QR</h3>
              <button 
                className="copy-button"
                onClick={handleCopy}
                title="Sao chép"
              >
                <FontAwesomeIcon icon={faCopy} />
                {copied && <span className="copied-tooltip">Đã sao chép!</span>}
              </button>
            </div>
            <div className="qr-result-content">
              <p>{qrResult}</p>
            </div>
          </div>

          <div className="qr-result-actions">
            <button 
              className="action-button primary"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Quay lại</span>
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default QRResult; 